'use client'
import {
  Headline,
  Subheadline,
  Container,
  ContentWrapper,
  CTAContainer
} from '@/components/ui'
import { CTAButton } from '@/components/ui/cta-button'
import MediaContainer from '@/components/ui/MediaContainer'
import GradientContainer from '@/components/ui/GradientContainer'
import { useCTAUrl } from '@/lib/use-cta-url'
import { GradientVariant, HeadlineVariant } from '@/types/ui'
import { usePageSettings } from '@/components/contexts/PageSettingsContext'
interface TaskWriterProps {
  gradientVariant?: GradientVariant
  headlineVariant?: HeadlineVariant
  title?: string
  subtitle?: string
}

const TaskWriter = ({ 
  gradientVariant = '12', 
  headlineVariant,
  title = "Say what you need. Get the task.",
  subtitle = "Hypertask learns your projects, so every ticket is context-aware. Just describe what you need and get clear, detailed tasks instantly."
}: TaskWriterProps) => {
  const { enableTaskWriterGoogleLogin, showGoogleLogoTaskWriter } = usePageSettings()
  const {href: ctaUrl, isCalendly} = useCTAUrl()
  return (
      <Container variant="section">
        <ContentWrapper gap="lg">
          <Headline variant={headlineVariant}>{title}</Headline>
          <Subheadline htmlContent={true}>
            {subtitle}
          </Subheadline>
          
          <GradientContainer gradientVariant={gradientVariant} variant="fullscreen">
            <MediaContainer 
              src="/images/sections/1758547129104ai_task_writer.avif" 
              type="image"
              alt="Task Writer Demo Video"
            />
          </GradientContainer>

          {/* CTA Button */}
          <CTAContainer marginTop="sm">
            <CTAButton
              href={ctaUrl}
              variant="primary"
              size="lg"
              className="w-full md:w-fit"
              enableGoogleLogin={enableTaskWriterGoogleLogin && !isCalendly}
              showGoogleLogo={showGoogleLogoTaskWriter}
              external={ctaUrl.startsWith('http')}
            >
              Try AI Tasking
            </CTAButton>
          </CTAContainer>
        </ContentWrapper>
      </Container>
  )
}

export default TaskWriter